import {CURRENCY_LOCALES} from "../appconstants";

export default (value, currency) => {
  if(isNumeric(value) && currency) {
    return parseFloat(value).toLocaleString(CURRENCY_LOCALES[currency], {
      maximumFractionDigits: 2,
      style: 'currency',
      currency: currency
    });
  }
  return value;
};

function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}
